module.exports = __webpack_public_path__ + "img/danger-circle-warning.60d2d63a.svg";